export const convertToFieldArray = (value, setAllFields) => {
  const fields = setAllFields(value);
  return Object.keys(fields).map(key => ({
    name: key,
    result: fields[key] === "N/A" ? "N/A" : fields[key],
  }));
};
